import { useContext } from 'react';

import { InputLabel } from '@/components/InputLabel/InputLabel';
// Components
import { Context } from '@/components/Store';
import { ActionTypes } from '@/components/Store.d';
// Modules
import { validateInput } from '@/lib/validator';

const PrintAccountNumber = () => {
  const [state, dispatch] = useContext(Context);

  return (
    <div className="form--text-compact">
      <InputLabel
        data-validation-error="Die Abo-Vorteilsnummer besteht aus 7 oder 8 Ziffern."
        defaultValue={state.printAccountNumber ? state.printAccountNumber : null}
        id="printAccountNumber"
        key="printAccountNumberInput"
        labelText="Abo-Vorteilsnummer"
        name="printAccountNumber"
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          if (validateInput(event.target)) {
            dispatch({
              type: ActionTypes.printAccountNumberChange,
              payload: {
                key: 'printAccountNumber',
                value: event.target.value
              }
            });
          }
        }}
        pattern="^\d{7,8}$"
        placeholder="Abo-Vorteilsnummer"
        required={true}
        type="text"
      />
    </div>
  );
};

export { PrintAccountNumber };
